import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Benefits">
                            <h2>Benefits Of API Integration And Development Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>TekRevol’s API development and integration have helped businesses scale their existing technology solutions to fit their needs better. With a custom API, your internal stakeholders and key decision-makers can utilize data and processed information to make strategies. It helps in sending analytics to an organization’s native ERP and CRM systems. Moreover, it connects internal and external devices. You can also share share important informational content on social channels and post marketing and sales data on relevant channels for remote access.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;